import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const USERNAME_KEY = 'omc_admin_username';
const AUTHED_KEY = 'omc_admin_authed';

// SECURITY NOTE: the admin JWT now lives ONLY in an httpOnly cookie set by the
// backend on login. It is never written to localStorage, so it cannot be read
// or exfiltrated by JavaScript / XSS. The `omc_admin_authed` flag below is NOT
// a credential — it only lets the route guard render synchronously. Protected
// API calls are authorized solely by the httpOnly cookie; a forged flag simply
// results in a 401 from the API and an immediate redirect to login.

export function getUsername() {
  return localStorage.getItem(USERNAME_KEY);
}

function setSession(username) {
  localStorage.setItem(AUTHED_KEY, '1');
  if (username) localStorage.setItem(USERNAME_KEY, username);
}

export function clearSession() {
  localStorage.removeItem(AUTHED_KEY);
  localStorage.removeItem(USERNAME_KEY);
}

export function isAuthenticated() {
  return localStorage.getItem(AUTHED_KEY) === '1';
}

/** Axios instance: sends the httpOnly cookie + handles 401s. */
export const adminApi = axios.create({
  baseURL: `${BACKEND_URL}/api/admin`,
  withCredentials: true,
});

adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      clearSession();
      if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/admin/login')) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  },
);

export async function login(username, password) {
  const url = `${BACKEND_URL}/api/admin/login`;
  const { data } = await axios.post(url, { username, password }, { withCredentials: true });
  if (data?.success) {
    setSession(data.username || username);
  }
  return data;
}

export async function logout() {
  try {
    await axios.post(`${BACKEND_URL}/api/admin/logout`, {}, { withCredentials: true });
  } catch (error) {
    // Logout still clears local state regardless of network outcome.
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.debug('admin logout network call failed; clearing local state anyway:', error?.message);
    }
  }
  clearSession();
}
